var common = require("../../utiles/common.js")
var c = require("../../utiles/entranceConfig");
var metaTypeUtils = require("../../utiles/metaTypeUtils");

module.exports = {
    getLoginEntrance:function(){
        var data = {};
        var context = common.getURLParameter("context");
        var loginEntrance = common.fetch("/auth/loginEntrance?context="+common.URIEncode(context)).data;
        for(var i=0;i<loginEntrance.length;i++){
            if(loginEntrance[i].authType){
                if(loginEntrance[i].authType === metaTypeUtils.authType.WECOM_QR){
                    data["QR"+i] = loginEntrance[i];
                }else if(loginEntrance[i].authType === metaTypeUtils.authType.USER_TICKET){
                    data["TICKET"] = loginEntrance[i];
                }else{
                    data[loginEntrance[i].authType] = loginEntrance[i];
                }
            }
        }
        return data;
    },
    getPriorityMax:function(data,notQR){
        var arr = [];
        for(var key in data){
            console.log(key)
            if(data[key].inheritTypes.indexOf(metaTypeUtils.metaType.QNAME_PRIORITY_LOGIN_ENTRANCE)>-1){
                if(data[key].priority){
                    if(!(notQR && key.indexOf("QR")>-1)){
                        arr.push({key:key,priority:data[key].priority});
                    }
                }
            }
        }
        function compare(property){
            return function(a,b){
                var value1 = a[property];
                var value2 = b[property];
                return value1 - value2;
            }
        }
        arr.sort(compare("priority"))
        console.log(arr)
        if(arr.length>0){
            return arr[arr.length-1]["key"];
        }
        return "PWD";
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/component/login/LoginUtils.js
// module id = 15
// module chunks = 0